export default "__VITE_ASSET__f0ab41ed__"